import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { BrandedLoadingState } from '@/components/common';
import { routes } from '@/config/routes';
import { useAuth } from '@/features/auth/context';
import { useDocumentMetadata } from '@/hooks/useDocumentMetadata';

export function LogoutPage() {
  useDocumentMetadata('Signing Out');
  const { logout } = useAuth();
  const navigate = useNavigate();
  const started = useRef(false);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    void logout().finally(() => navigate(routes.home, { replace: true }));
  }, [logout, navigate]);
  return <BrandedLoadingState label="Signing you out…" />;
}
